import { IonContent, IonIcon } from '@ionic/react';
import { globeOutline } from 'ionicons/icons';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { DIALOGUE_SUPPORT_EMAIL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { apiV1GetMeAuthRequest } from '@/modules/api';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

import { SuccessPageStyles, WebVersionLink } from './MultigenderOnlyWeb.styles';

interface MultigenderOnlyWebBaseProps {
  backgroundImage: string;
}

const MultigenderOnlyWebBase: React.FC<MultigenderOnlyWebBaseProps> = ({
  backgroundImage,
}) => {
  const { user } = useAccount();
  const [authToken, setAuthToken] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchAuthToken = async () => {
      const auth = await apiV1GetMeAuthRequest();
      setAuthToken(auth.token);
    };
    fetchAuthToken();
  }, []);

  return (
    <SuccessPageStyles backgroundImage={backgroundImage}>
      <IonContent scrollY={false}>
        <div className="content">
          <OnboardingTitle className="success-payment-title">
            Congrats, your purchase
            <br /> was successful!
          </OnboardingTitle>
          <div className="next-actions">
            <UiTypography
              align="center"
              variant="body-large"
              className="next-action-description"
            >
              Choose the platform
            </UiTypography>
            {webCampaign.setup.hasWebAppLink && !!authToken && (
              <WebVersionLink>
                <a href={webCampaign.getAuthUrl(authToken)} target="_blank">
                  <IonIcon icon={globeOutline} />
                  <UiTypography
                    variant="label-large"
                    color="white"
                    component="span"
                  >
                    Web version
                  </UiTypography>
                </a>
              </WebVersionLink>
            )}

            <UiTypography variant="body-large" align="center">
              OR via the link we sent to {user?.email} (check Inbox and Spam
              folders).
            </UiTypography>
          </div>

          <div className="questions-email">
            <UiTypography variant="body-large" align="center">
              If you have any questions - reach us at{' '}
              <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`}>
                {DIALOGUE_SUPPORT_EMAIL}
              </a>
            </UiTypography>
          </div>
        </div>
      </IonContent>
    </SuccessPageStyles>
  );
};

export default MultigenderOnlyWebBase;
